module.exports = __webpack_public_path__ + "assets/img/page_5.ca938367.png";